import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import ComplimentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/complimentImagesIcon.svg?react';
import DamagedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/damagedImagesIcon.svg?react';
import DocumentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/documentImagesIcon.svg?react';
import VehicleImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/vehicleImagesIcon.svg?react';
import { AdjusterImageTabType } from '@/modules/adjusterReportModules/IncidentParticipants/types/images';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { getBodyCustomerImagesTabsOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerImagesTabs/getBodyCustomerImagesTabsOptions';
import { BodyAdjusterImageTabType } from '@/modules/adjusterReportModules/Insurer-information/types/Bodyimages';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title=" تصاویر / بیمه گذار" header="titleHeader">
      <BodyCustomerImagesTabs />
    </MainLayout>
  );
};

const BodyCustomerImagesTabs = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, isPending } = useQuery(
    getBodyCustomerImagesTabsOptions({
      id: +id!,
    }),
  );

  const renderRoute = (tabName: BodyAdjusterImageTabType['name']) => {
    const BODY_DAMAGE_IMAGES = ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES(
      { id: id! },
    );
    let tabIcon: Record<BodyAdjusterImageTabType['name'], string> = {
      additional_image: BODY_DAMAGE_IMAGES.customerAdditional,
      document_image: BODY_DAMAGE_IMAGES.customerDocument,
      vehicle_image: BODY_DAMAGE_IMAGES.customerVehicle,
    };
    return tabIcon[tabName];
  };
  const goToFile = (tabName: BodyAdjusterImageTabType['name']) => {
    navigate(renderRoute(tabName));
  };
  return (
    <Box pt="2rem" mt="4rem">
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            position: 'relative',
            top: '-5px',
          })}
        >
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            })}
          >
            <TitleDescription>تصاویر مشتری</TitleDescription>
            <Box>
              {data?.map((item, index) =>
                !item.is_card_active ? null : (
                  <CardButton
                    key={item?.name}
                    cardProps={{
                      className: css({
                        marginY: '1rem',
                        marginTop: index === 0 ? '0rem' : '1rem',
                        marginBottom:
                          index === data.length - 1 ? '0rem' : '1rem',
                      }),
                      onClick: () => goToFile(item?.name),
                    }}
                    hasArrow
                    renderIcon={() => renderIcon(item?.name)}
                    title={item?.fa_name}
                  />
                ),
              )}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

const renderIcon = (tabName: BodyAdjusterImageTabType['name']) => {
  let tabIcon: Record<AdjusterImageTabType['name'], React.JSX.Element> = {
    additional_image: <ComplimentImagesIcon />,
    document_image: <DocumentImagesIcon />,
    vehicle_image: <VehicleImagesIcon />,
    damaged_image: <DamagedImagesIcon />,
  };
  return tabIcon[tabName];
};
